export const ANOTHER_FILE_LOCKED = "ANOTHER_FILE_LOCKED";

export const FILE_ALREADY_LOCKED = "FILE_ALREADY_LOCKED";

export const FILE_NOT_LOCKED_BY_USER = "FILE_NOT_LOCKED_BY_USER";
